import { useCallback, useEffect, useState } from 'react';

import Tooltip from '@mui/material/Tooltip';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import { GridActionsCellItem } from '@mui/x-data-grid';

import { EMPTY_STRING } from '@e-socna/empty';

import { wrapExpression } from '../../utils/handlebars-expression.util';
import type { ReferencesContext_Resolver } from '../../contexts/ReferencesContext';

import { useContentGenerator } from '../DocumentEditor/hooks/useContentGenerator.hook';

import type { OnSelectHandler } from './types/on-select-handler.type';

interface Props {
  readonly resolver: Readonly<ReferencesContext_Resolver>;
  readonly onSelect: OnSelectHandler;
  readonly setIsLoading: (isLoading: boolean) => void;
}

export const DirectGenerationAction = ({
  resolver,
  onSelect: handleContentGenerated,
  setIsLoading,
}: Readonly<Props>) => {
  const [enableContentGenerator, setEnableContentGenerator] = useState(false);

  const handleActionClick = useCallback(() => {
    setEnableContentGenerator(true);
  }, []);

  const { data, isLoading, isSuccess } = useContentGenerator({
    enabled: enableContentGenerator,
    template: wrapExpression(resolver.command),
  });

  useEffect(() => {
    setIsLoading(isLoading);
  }, [isLoading, setIsLoading]);

  useEffect(() => {
    if (!isSuccess) {
      return;
    }

    handleContentGenerated('directGeneration', data?.generated ?? EMPTY_STRING);
  }, [data?.generated, handleContentGenerated, isSuccess]);

  const actionLabel = 'Générer le contenu';

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={actionLabel}>
          <SettingsSuggestIcon />
        </Tooltip>
      }
      label={actionLabel}
      onClick={handleActionClick}
    />
  );
};
